/**
 * Not pass, `styled()` 사용 시 `shouldForwardProp`에 통과시키지 않을 string만 전달
 *
 * @example
 * styled('button', { shouldForwardProp: np('loading', 'ownerState') })``
 */
export function np(...args: string[]) {
  return (prop: string) => !args.includes(prop);
}
